import React, { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { BlurText } from './BlurText';
import './Hero.css';

const Hero = () => {
  const { t } = useTranslation();
  
  // High-quality construction/architectural background images
  const backgroundImages = [
    'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2000', // Modern glass building
    'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?q=80&w=2000', // Construction site
    'https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=2000', // Architectural structure
  ];
  
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        (prevIndex + 1) % backgroundImages.length
      );
    }, 6000); // Change image every 6 seconds

    return () => clearInterval(interval);
  }, []);

  const handleCTAClick = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      const headerOffset = 120;
      const elementPosition = contactSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="hero" id="hero">
      <div className="hero-background">
        <div className="hero-overlay"></div>
        {backgroundImages.map((image, index) => (
          <div
            key={index}
            className={`hero-image-slide ${
              index === currentImageIndex ? 'active' : ''
            } ${
              index === (currentImageIndex - 1 + backgroundImages.length) % backgroundImages.length
                ? 'previous'
                : ''
            }`}
            style={{ backgroundImage: `url(${image})` }}
          />
        ))}
      </div>
      
      <div className="hero-content">
        <div className="hero-text">
          <BlurText
            text={t('hero.title')}
            delay={50}
            animateBy="words"
            direction="top"
            className="hero-main-title-blur"
          />
          
          <BlurText
            text={t('hero.description')}
            delay={80}
            animateBy="words"
            direction="bottom"
            className="hero-description-blur"
          />
          
          <button 
            className="btn-primary hero-cta-animated" 
            onClick={handleCTAClick}
          >
            {t('hero.cta')}
            <ArrowRight size={20} />
          </button>
        </div>
      </div>
      
      <div className="hero-scroll-indicator">
        <div className="scroll-line"></div>
      </div>
      
      <div className="hero-slideshow-indicators">
        {backgroundImages.map((_, index) => (
          <button
            key={index}
            className={`indicator-dot ${index === currentImageIndex ? 'active' : ''}`}
            onClick={() => setCurrentImageIndex(index)}
            aria-label={`Slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
